import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

class Uploader extends Component {
  render() {
    const {
      label,
      name,
      source,
      type,
      inputlabel,
      accept,
      id,
      value,
      error,
      onLoad,
      onChange,
    } = this.props;

    return (
      <Fragment>
        <div className="row mt-1 align-items-center">
          <div
            className={type === "image" ? "col-sm-8 mb-3" : "col-sm-12 mb-3"}
          >
            <label htmlFor={name}>{label}</label>
            <div className="custom-file">
              <input
                type="file"
                className="custom-file-input"
                id={name}
                onChange={onChange}
                accept={accept}
              />
              <label className="custom-file-label rounded" htmlFor={name}>
                {inputlabel !== "" ? inputlabel : "Choose File..."}
              </label>
            </div>
          </div>

          {type === "image" && (
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor={id}>Aspect Ratio</label>
                <input
                  id={id}
                  name={id}
                  value={value}
                  type="number"
                  className="form-control rounded"
                  disabled={true}
                />
                {error && <div className="alert alert-danger">{error}</div>}
              </div>
            </div>
          )}
        </div>

        <div
          className="row mt-3 pb-4"
          style={{ display: source ? "" : "none" }}
        >
          <div className="col">
            {type === "audio" ? (
              <audio
                src={source}
                id={id}
                onLoad={onLoad}
                onLoadedData={onLoad}
                controls={true}
                className="w-100 mt-3 audio-tag rounded"
              />
            ) : (
              <div className="card placeholder" style={{ height: "265px" }}>
                <div className="card-body placeholder-body">
                  <div
                    className="vertical-scroll"
                    style={{ maxHeight: "265px" }}
                  >
                    {type === "image" && (
                      <img
                        className="image-preview"
                        src={source}
                        id={id}
                        alt={name}
                        onLoad={onLoad}
                      />
                    )}
                    {type === "video" && (
                      <video
                        src={source}
                        id={id}
                        onLoad={onLoad}
                        onLoadedData={onLoad}
                        controls={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

// Typechecking
Uploader.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  inputlabel: PropTypes.string.isRequired,
  accept: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.object,
  onLoad: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Uploader;
